import FileIcon from "@entrilia/shared/components/FileIcon";
import { getFileExtension } from "@entrilia/shared/utilities/fileHelper";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineRounded";
import { Chip, CircularProgress, Tooltip } from "@mui/material";

interface Props {
  name: string;
  isUploading?: boolean;
  error?: string;
  onClick?: () => void;
  onDelete?: () => void;
}

const getChipIcon = (name: string, isUploading: boolean | undefined, error: string | undefined) => {
  if (isUploading) {
    return <CircularProgress size={16} />;
  }

  if (error) {
    return <ErrorOutlineIcon />;
  }

  return <FileIcon fileExtension={getFileExtension(name)} />;
};

const ChatFileChip = ({ name, isUploading, error, onClick, onDelete }: Props) => (
  <Tooltip title={isUploading ? "Uploading and checking for viruses…" : ""}>
    <Chip
      variant="outlined"
      color={error ? "error" : "default"}
      icon={getChipIcon(name, isUploading, error)}
      label={error ? `${name}: ${error}` : name}
      onClick={onClick}
      onDelete={onDelete}
      sx={{
        maxWidth: "100%",
        height: "auto",
        p: 0.5,
        "& .MuiChip-label": { whiteSpace: "normal", overflowWrap: "anywhere" },
      }}
    />
  </Tooltip>
);

export default ChatFileChip;
